import { format, parseISO } from 'date-fns'

import { ApiError } from '@/services/api/envelope'

export const formatDate = (iso: string): string => format(parseISO(iso), 'dd.MM.yyyy')
export const formatTime = (iso: string): string => format(parseISO(iso), 'HH:mm')
export const formatTimeSec = (iso: string): string => format(parseISO(iso), 'HH:mm:ss')
export const formatDateTime = (iso: string): string => format(parseISO(iso), 'dd.MM.yyyy HH:mm')
export const formatDateTimeSec = (iso: string): string =>
  format(parseISO(iso), 'dd.MM.yyyy HH:mm:ss')
/** Подпись у текущих показателей по ТЗ (п. 3.3): «Обновлено: 21.08.2026 23:48». */
export const formatUpdatedAt = (iso: string): string => `Обновлено: ${formatDateTime(iso)}`
/** Штамп в стиле видеорегистратора: 2026-08-21 19:42:10. */
export const formatFrameStamp = (iso: string): string =>
  format(parseISO(iso), 'yyyy-MM-dd HH:mm:ss')

/** Русская плюрализация: plural(3, 'визит', 'визита', 'визитов'). */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n)) % 100
  const last = abs % 10
  if (abs > 10 && abs < 20) return many
  if (last > 1 && last < 5) return few
  if (last === 1) return one
  return many
}

export const formatPercent = (ratio: number): string => `${Math.round(ratio * 100)}%`

export const formatDecimal = (value: number, digits = 1): string =>
  value.toLocaleString('ru-RU', { minimumFractionDigits: digits, maximumFractionDigits: digits })

export function getErrorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message
  if (error instanceof Error) return error.message
  return 'Неизвестная ошибка'
}
